import { Box, Button, CircularProgress, Modal, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useCallback, useEffect, useState } from "react";
import styles from "../../pages/app/Nurture/components/PaymentType/PaymentType.module.css";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useAuthUser } from "react-auth-kit";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  convertToAdjustedTimestamp,
  timeZoneConverter,
} from "../Formatter/Formatter";
import {
  activateEnach,
  getLeadListByInstituteAndContact,
  resetActivateEnachSuccess,
} from "../../pages/app/Nurture/service/nurtureSlice";
import enach from "../../assets/images/enach.svg";
import { GetCourseByIdRequest } from "../../pages/app/Manage/ManageCourse/service/course.request";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "95%",
    sm: "50%",
    lg: 430,
    xl: 430,
    md: 430,
  },
  bgcolor: "background.paper",
  border: "none",
  boxShadow:
    "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
  borderRadius: "12px",
  p: "20px",
};
//To avail the payment options, Please select a batch first.
const EnachConfirmPopup = ({
  setOpenEnachPopup,
  openEnachPopup,
  leadById,
}: any) => {
  const [total, setTotal] = useState<string>("");
  const [paymentNameError, setPaymentNameError] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);

  const auth = useAuthUser();
  const authUser = auth();

  const [endDate, setEndDate] = React.useState<any>(moment().unix());
  const [endDateOfEnach, setEndDateOfEnach] = useState(`${moment().unix()}`);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const { activateEnachLoading, activateEnachSuccess } = useSelector(
    (state: any) => state.nurture
  );

  useEffect(() => {
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
    }, 3000);
  }, []);

  const closePaymentLinkPopup = () => {
    setOpenEnachPopup(false);
    dispatch(resetActivateEnachSuccess());
  };

  const handleNameChange = React.useCallback((value: any) => {
    setTotal(value);
    if (value) {
      setPaymentNameError(false);
    } else {
      setPaymentNameError(true);
    }
  }, []);

  useEffect(() => {
    if (activateEnachSuccess === true) {
      closePaymentLinkPopup();
      leadPopupApiCall(
        leadById?.instituteId,
        leadById?.studentContact,
        leadById?.studentEmail
      );
    }
  }, [activateEnachSuccess]);

  const leadPopupApiCall = useCallback(
    (instituteId: string, phone: string | null, email: string | null) => {
      let data: any;
      if (instituteId) {
        if (phone) {
          data = {
            id: instituteId,
            phone: phone,
          };
          dispatch<any>(getLeadListByInstituteAndContact(data));
        } else if (email) {
          data = {
            id: instituteId,
            email: email,
          };
          dispatch<any>(getLeadListByInstituteAndContact(data));
        }
      }
    },
    [getLeadListByInstituteAndContact]
  );

  const handleRecordPayment = async () => {
    const body = {
      instituteId: authUser?.institute[0]?.instituteId,
      enquiryId: leadById?.id,
      endDate: endDateOfEnach,
      max_debit_amount: total,
      autoDebitType: "ENACH",
    };
    try {
      dispatch<any>(activateEnach(body));
    } catch (error) {}
  };

  const handleDateChange = (date: any, id: string) => {
    if (date !== null) {
      if (id === "endDate") {
        const newEndDate: any = new Date(date).setHours(23, 59, 59, 0);
        setEndDate(date.unix());
        setEndDateOfEnach(timeZoneConverter(newEndDate));
      }
    }
  };

  useEffect(() => {
    if (leadById?.paymentDetails?.paymentType === "MEMBERSHIP") {
      const value =
        leadById?.paymentDetails?.EMIDetails?.emiMode === "MONTHLY"
          ? leadById?.paymentDetails?.finalAmount * 12
          : leadById?.paymentDetails?.EMIDetails?.emiMode === "TWO_MONTHS"
          ? leadById?.paymentDetails?.finalAmount * 6
          : leadById?.paymentDetails?.EMIDetails?.emiMode === "QUARTERLY"
          ? leadById?.paymentDetails?.finalAmount * 4
          : leadById?.paymentDetails?.EMIDetails?.emiMode === "HALF_YEARLY"
          ? leadById?.paymentDetails?.finalAmount * 2
          : leadById?.paymentDetails?.finalAmount;
      setTotal(value);
      const oneYearLaterUnix = moment().add(1, "year").unix();
      setEndDate(oneYearLaterUnix);
      setEndDateOfEnach(timeZoneConverter(oneYearLaterUnix));
    } else if (leadById?.paymentDetails?.paymentType === "REGULAR") {
      setTotal(leadById?.balanceAmount);
      setEndDate(convertToAdjustedTimestamp(leadById?.bacthEndDate) / 1000);
      setEndDateOfEnach(leadById?.bacthEndDate);
    }
  }, [leadById]);

  return (
    <Modal
      open={openEnachPopup}
      onClose={closePaymentLinkPopup}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ zIndex: isCalendarOpen ? "999" : "99999999" }}
    >
      {loader ? (
        <Box
          sx={style}
          style={{
            padding: "20px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={25} color={"inherit"} />
        </Box>
      ) : (
        <Box sx={style} style={{ padding: "20px" }}>
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ fontWeight: "500" }}>Activate Easy EMI's</div>
              <div
                onClick={closePaymentLinkPopup}
                className={styles.closeModalButton}
              >
                <CloseIcon />
              </div>
            </div>
            <div>
              <div className={styles.customTypeFieldLabel}>
                Simple and flexible per-user pricing.
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "10px",
                  border: "1px solid rgba(17, 200, 155, 1)",
                  borderRadius: "8px",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    fontSize: "20px",
                    color: "rgba(24, 29, 39, 1)",
                    fontWeight: "600",
                  }}
                >
                  {`₹${Math.abs(Number(total))?.toFixed(2)}/-`}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    color: "rgba(24, 29, 39, 1)",
                    fontWeight: "600",
                  }}
                >
                  Maximum deductible Amount
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    color: "rrgba(83, 88, 98, 1)",
                    fontWeight: "400",
                  }}
                >
                  {`End Date ${moment.unix(endDate).format("Do MMM YYYY")}`}
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "10px",
                border: "1px solid rgba(233, 234, 235, 1)",
                borderRadius: "8px",
                flexDirection: "row",
                marginTop: "15px",
                gap: "10px",
              }}
            >
              <div>
                <img
                  src={enach}
                  alt={"level"}
                  style={{
                    height: "40px",
                  }}
                />
              </div>
              <div
                style={{
                  fontSize: "13px",
                  color: "rgba(65, 70, 81, 1)",
                  fontWeight: "400",
                }}
              >
                For Regular and Installment payment, the maximum amount for Easy
                EMI's will be total amount of the course fee and the end date
                will be the end date of Batch.
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "10px",
                border: "1px solid rgba(233, 234, 235, 1)",
                borderRadius: "8px",
                flexDirection: "row",
                marginTop: "15px",
                gap: "10px",
              }}
            >
              <div>
                <img
                  src={enach}
                  alt={"level"}
                  style={{
                    height: "40px",
                  }}
                />
              </div>
              <div
                style={{
                  fontSize: "13px",
                  color: "rgba(65, 70, 81, 1)",
                  fontWeight: "400",
                }}
              >
                For Subscription payment the maximum amount for Easy EMI's will
                be 12x Monthly fees, 2x Half yearly fees, 4x Quaterly fees and
                the End date will be the 1 Year from the date of request.
              </div>
            </div>
            <div className={styles.leadRandomPayPopup}>
              <Button
                variant="outlined"
                type="reset"
                sx={{
                  color: "#BFBFBF",
                  borderColor: "#BFBFBF",
                  textTransform: "capitalize",
                  minWidth: "100px",
                }}
                onClick={() => {
                  closePaymentLinkPopup();
                }}
              >
                Cancel
              </Button>

              <Button
                sx={{ textTransform: "capitalize", minWidth: "100px" }}
                variant="contained"
                onClick={() => {
                  handleRecordPayment();
                }}
                disabled={paymentNameError || total === ""}
              >
                {activateEnachLoading ? (
                  <CircularProgress size={20} color={"inherit"} />
                ) : (
                  "Confirm"
                )}
              </Button>
            </div>
          </>
        </Box>
      )}
    </Modal>
  );
};

export default EnachConfirmPopup;
